export default {"src":"/_next/static/media/outer-4.e5e0bc5a.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};